import React from "react";
import PropTypes from "prop-types";
import {
  useDeleteHolidayMutation,
  useGetHolidaysQuery,
} from "src/api/holidaysApiSlice";
import { getDay, getDayText, getFormattedDate } from "src/utilities/dataFns";
import styled from "@emotion/styled";
import { HorizontalGap } from "../styled/gaps";
import { Delete as DeleteIcon } from "@mui/icons-material";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const DateText = styled.div`
  color: #3d4253;

  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const ReasonText = styled.div`
  color: #3d4253;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const HolidaysList = (props) => {
  const { data, isLoading, isSuccess, isError, error } = useGetHolidaysQuery();
  const [deleteHoliday] = useDeleteHolidayMutation();

  const handleDelete = () => {};
  if (isLoading) {
    return "Loading...";
  }
  if (isError) {
    return `${error.message}`;
  }
  if (isSuccess) {
    return (
      <div>
        <div>Upcoming Holidays</div>
        <div>
          {data && data.length && data.length > 0
            ? data.map((h, i) => (
                <Row key={i}>
                  <DateText>{getFormattedDate(h.date)}</DateText>
                  <HorizontalGap size={"10px"} />
                  <DateText>{getDayText(h.date)}</DateText>
                  <HorizontalGap size={"10px"} />
                  <ReasonText>{h.description}</ReasonText>
                  <HorizontalGap size={"10px"} />
                  <DeleteIcon
                    sx={{ color: "red", cursor: "pointer" }}
                    onClick={() => deleteHoliday(h._id)}
                  />
                </Row>
              ))
            : "No upcoming holidays"}
        </div>
      </div>
    );
  }
};

export { HolidaysList };
